// 録音 CTA の kakeru アプリ差寸法・輪郭 (design-book 02-components/recording-control.md).
// 主役 CTA (RecordingControl の mic / 停止) と paused の再開 (PatientInfoBar) が
// 同意匠で参照する共有定数. 値の変更は本書 → 本ファイルの 1 箇所で両者に波及させる.
export const RECORDING_CTA_SIZE = 56

// mic / play glyph の寸法 (SIZE とセットで拡大. ICON_SIZE 枠外の decorative 指定).
export const RECORDING_CTA_GLYPH_PX = 28

// 輪郭: currentColor 参照で状態色 (idle 青 / recording 緑 / disabled 灰) に自動追従.
// 地塗りなし意匠で押下領域 (56px 円) が glyph の外に見えないための可視化.
// 濃度は 40% 固定 (罫線は半透明を最優先の color.md 流儀. color-mix なのは rgba
// 直書きだと状態ごとの分岐が要るため). hover でも不変 (hover は overlay.selected
// 塗りの 1 チャネルのみ. 輪郭の濃色化は選択/活性化と読め信号が二重になる).
export const RECORDING_CTA_OUTLINE =
  '1.5px solid color-mix(in srgb, currentColor 40%, transparent)'
